import { FormDropdown } from 'components/shared/Forms/ReduxForm'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { Header } from 'semantic-ui-react'
import Placeholder from '../../Helper/Placeholder'

const mapStateToProps = (state, ownProps) => {
  const { pathLeaves, categoryPathsLoading } = state.categories
  return { pathLeaves, pathLeavesLoading: categoryPathsLoading }
}

class ProductCategorySelector extends React.Component {
  render() {
    // redux
    const { pathLeaves, categoryPathsLoading } = this.props
    // params
    const { onChange } = this.props
    // TODO: warning about properties and title_de / title_fr
    // error only occurs sometimes and in the first batch of arrays. I suppose it's a mixup in reducer

    return categoryPathsLoading ? (
      <Placeholder />
    ) : (
      <div className="ProductCategorySelector">
        <Header
          as="h3"
          dividing
          content={I18n.t('admin.productCategorySelector.title')}
        />
        <Field
          component={FormDropdown}
          fluid
          multiple
          selection
          placeholder={I18n.t('admin.productCategorySelector.select')}
          /*TODO: add key to each entry to avid missing keys warnings*/
          options={pathLeaves}
          onChange={onChange}
          name="product_categories"
          onLabelClick={(_, e) => console.log(e.content)}
          search={(options,search) => options.filter(option => option.text.toLowerCase().includes(search.toLowerCase()))}
        />
      </div>
    )
  }
}

ProductCategorySelector = connect(mapStateToProps)(ProductCategorySelector)
export default ProductCategorySelector



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductCategorySelector.jsx